// extracted by mini-css-extract-plugin
export default {"h2":"Title_h2__BdHDO","h3":"Title_h3__PucfW","h4":"Title_h4__A6RY+","h5":"Title_h5__gMGgC","h6":"Title_h6__Pk97U"};